import { createFileRoute } from '@tanstack/react-router'
import { DeliveryMethodEditor } from './-DeliveryMethodEditor'

export const Route = createFileRoute('/settings/logistics/delivery-methods/$id')({
  component: DeliveryMethodDetailPage,
})

function DeliveryMethodDetailPage() {
  const { id } = Route.useParams()
  return <DeliveryMethodEditor id={id} />
}
